import { generateTokenApi, postLoginApi } from "../api/auth.api"

export const generateTokenAction = (payload, handleError) => {
    return async dispatch => {
      try {
        const data = await generateTokenApi(payload, handleError)
        dispatch({
          type: 'GENERATE_TOKEN',
          payload: { data }
        })
        return data
      } catch (error) {
        console.log('error', error)
      }
    }
  }

  export const postLoginAction = (jwtToken, payload) => {
    console.log(jwtToken, payload)
    return async dispatch => {
      try {
        const data = await postLoginApi(jwtToken, payload)
        dispatch({
          type: 'SIGN_IN',
          payload: { data }
        })      
        return data
      } catch (error) {
        console.log('error', error)
      }
    }
  }

  export const logout = () => {
    return dispatch => {
      dispatch({
        type: 'SIGNOUT'
      })
      sessionStorage.removeItem('persist:root')
    }
  }